<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { TextField } from '@haskoning/vue-component-library'
import { useProjectParameterStore } from '@/stores/projectParameter'
import { useAuthorizationStore } from '@/stores/authorization'

const projectParameterStore = useProjectParameterStore()
const authorizationStore = useAuthorizationStore()

const { currentItem, fields } = storeToRefs(projectParameterStore)

const canChangeProjectParameter = computed(() => {
	return authorizationStore.hasServicePermission({
		authSource: 'ProjectUser',
		allowed: ['change_projectparameter']
	})
})
</script>

<template>
	<v-card flat class="px-3">
		<v-row no-gutter v-if="currentItem && fields">
			<v-col cols="6" class="pr-2">
				<TextField
					:field="fields['water_unit_weight']"
					v-model="currentItem"
					hide-details
					@update="projectParameterStore.update(currentItem)"
					:readonly="!canChangeProjectParameter"
				></TextField>
			</v-col>

			<v-col cols="6">
				<TextField
					:field="fields['pre_drilling_weight']"
					v-model="currentItem"
					hide-details
					@update="projectParameterStore.update(currentItem)"
					:readonly="!canChangeProjectParameter"
				></TextField>
			</v-col>

			<v-col cols="6">
				<TextField
					:field="fields['atmospheric_pressure']"
					v-model="currentItem"
					hide-details
					@update="projectParameterStore.update(currentItem)"
					:readonly="!canChangeProjectParameter"
				></TextField>
			</v-col>
		</v-row>
	</v-card>
</template>
